import { createSlice } from '@reduxjs/toolkit';

export const options = createSlice({
  name: 'options',
  initialState: {
    isVoiceMailActive: false,
    optionsIsLoading: true,
    response: null,
    numberOfRings: [
      0,
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
    ],
    announcements: [],
    assignedAnnouncement: '',
    defaultAnnouncement: '',
    greetingToRemove: null,
    pinNumber: '••••',
  },
  reducers: {
    setOptionsIsLoading: (state, action) => {
      state.optionsIsLoading = action.payload;
    },
    setOptionsResponse: (state, action) => {
      state.response = action.payload;
    },
    setIsVoiceMailActive: (state, action) => {
      state.isVoiceMailActive = action.payload;
    },
    setAnnouncements: (state, action) => {
      state.announcements = action.payload;
    },
    setAssignedAnnouncement: (state, action) => {
      state.assignedAnnouncement = action.payload;
    },
    setDefaultAnnouncement: (state, action) => {
      state.defaultAnnouncement = action.payload;
    },
    setGreetingToRemove: (state, action) => {
      state.greetingToRemove = action.payload;
    },
    setPinNumber: (state, action) => {
      state.pinNumber = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setOptionsIsLoading,
  setOptionsResponse,
  setIsVoiceMailActive,
  setAnnouncements,
  setAssignedAnnouncement,
  setDefaultAnnouncement,
  setEmailToCarbonCopy,
  setGreetingToRemove,
  setPinNumber,
} = options.actions;

export default options.reducer;
